import {
  createReqConsts,
  createActions,
  createReqWatcher,
  createReqReducer,
} from '../../../utils/redux';

const makeUpdateGuarantorConfig = () => ({
  endpoint: 'users',
  type: 'put',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'guarantors',
    {
      type: 'payload',
      selector: ['id'],
    },
  ],
});

const requestOptions = makeUpdateGuarantorConfig();

export const consts = createReqConsts('update-guarantor');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, requestOptions, true);

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/guarantor-information/requests/update-guarantor-req.js